import * as Actions from '../../actions/vendor/type';

const initialState = {
  vendorLoading: false,
  importVendorsData: '',
  importVendorError: null,
};
const VendorReducer = (state = initialState, action) => {
  switch (action.type) {
    // Import vendors

    case Actions.IMPORT_VENDOR_REQUEST:
      return {
        ...state,
        vendorLoading: true,
      };
    case Actions.IMPORT_VENDOR_SUCCESS:
      return {
        ...state,
        vendorLoading: false,
        importVendorsData: action.payload,
      };
    case Actions.IMPORT_VENDOR_FAIL:
      return {
        ...state,
        vendorLoading: false,
        importVendorError: action.payload,
      };
    case Actions.CLEAR_IMPORT_VENDOR_STATE:
      return {
        ...state,
        vendorLoading: false,
        importVendorsData: '',
        importVendorError: null,
      };
    default:
      return state;
  }
};

export default VendorReducer;
